import React, {useEffect} from 'react';
import Autocomplete from '@mui/material/Autocomplete';
import IconButton from '@mui/material/IconButton';
import _ from 'lodash';
import makeStyles from '@mui/styles/makeStyles';
import {ListItem, ListItemSecondaryAction, ListItemText, TextField} from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';

const style = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.field,
    borderRadius: 10,
    '& fieldset': {
      border: ({border}) =>
        border
          ? `1px solid
       white`
          : 'none',
    },
  },
}));

const FiledWithHistory = (props) => {
  const classes = style({
    border: props.border,
  });

  const [value, setValue] = React.useState(props.value || '');
  const [reference, setReference] = React.useState(props.value || '');
  const [searchHistoryReference, setSearchHistoryReference] = React.useState(
    [],
  );

  useEffect(() => {
    if (_.isArray(searchHistoryReference)) {
      setSearchHistoryReference(props.history);
    }
  }, [props.history]);

  useEffect(() => {
    setReference(props.value || '');
    setValue(props.value || '');
  }, [props.value]);

  const handleSubmit = async (e) => {
    if (e.key === 'Enter' && !_.isNil(value)) {
      setReference(value);
      handleAddHistory(value);

      props.handleSubmit(value);
    }
  };

  const handleAddHistory = (history) => {
    if (!_.isEmpty(history)) {
      let clone = _.cloneDeep(searchHistoryReference);
      const index = clone.indexOf(history);
      if (index === -1) {
        clone.unshift(history);
        if (clone.length > 5) {
          clone = clone.slice(0, 5);
        }
        setSearchHistoryReference(clone);
        props.saveHistory(clone);
      }
    }
  };

  const handleDeleteHistory = (history) => {
    const clone = _.cloneDeep(searchHistoryReference);
    const newHist = _.filter(clone, (opt) => opt !== history);
    setSearchHistoryReference(newHist);
    props.saveHistory(newHist);
  };

  const handleSelectValue = (selectedValue) => {
    const clone = _.filter(
      searchHistoryReference,
      (ref) => ref !== selectedValue,
    );
    clone.unshift(selectedValue);

    setSearchHistoryReference(clone);
    props.saveHistory(clone);
    props.handleSubmit(selectedValue);
  };

  return (
    <Autocomplete
      freeSolo
      onKeyDown={handleSubmit}
      size={props?.size || 'small'}
      value={reference}
      onChange={(event, newValue) => {
        if (newValue) {
          handleSelectValue(newValue);
          setValue(newValue);
          setReference(newValue);
        }
      }}
      onInputChange={(event, newInputValue) => {
        setValue(newInputValue);
      }}
      disabled={props.disabled}
      options={searchHistoryReference}
      renderOption={(props, option, state) => (
        <ListItem {...props}>
          <ListItemText primary={option}/>
          <ListItemSecondaryAction>
            <IconButton
              edge="end"
              aria-label="delete"
              onClick={(e) => handleDeleteHistory(option)}
            >
              <DeleteIcon/>
            </IconButton>
          </ListItemSecondaryAction>
        </ListItem>
      )}
      renderInput={(params) => (
        <TextField
          {...params}
          onChange={(e) => setReference(e.target.value)}
          placeholder={props.placeholder || ''}
          variant="outlined"
          fullWidth
          className={classes.root}
          disabled={props.disabled}
        />
      )}
    />
  );
};

export default FiledWithHistory;
